import React, { useState } from "react";
import styled from "styled-components";
import ModalPrivacyPolicy from "./Modal/ModalPrivacyPolicy.jsx";

// 로그인 뒤 화면에는 하단 정보가 없어 사이드바 이용약관 아래에서 처리방침을 연다.
// inset은 함께 놓인 메뉴의 왼쪽 여백이고, 글자는 메뉴 아이콘(32px)과 간격(8px) 뒤 메뉴 이름에 맞춘다.
const PrivacyPolicyLink = ({ inset = 20 }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <Button type="button" $inset={inset} onClick={() => setIsOpen(true)}>
        개인정보 처리방침
      </Button>
      <ModalPrivacyPolicy isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

const Button = styled.button`
  width: 100%;
  height: 32px;
  flex-shrink: 0;
  border: 0;
  padding: 0 0 0 ${({ $inset }) => $inset + 40}px;
  background: transparent;
  color: rgba(0, 0, 0, 0.6);
  font-family: Pretendard, sans-serif;
  font-size: 13px;
  font-weight: 700;
  text-align: left;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export default PrivacyPolicyLink;
